/*!
 * American Well Online Care
 *
 * Copyright © 2021 American Well.
 * All rights reserved.
 *
 * It is illegal to use, reproduce or distribute
 * any part of this Intellectual Property without
 * prior written authorization from American Well.
 */

export class PatientFhirData {
  public mobilePhone: string;
  public displayName: string;
  public firstName: string;
  public lastName: string;
  public dateOfBirth: string;
  public gender: string;
  public addresses: [];
  public phoneNumbers: [];
  public emailAddresses: [];
  public preferredLanguage: string;
  public medicalRecordNumber: string;
  public reference: string;
  public externalUserId: string;

  constructor() { }
}
